export var cardanChangeFormModel = function cardanChangeFormModel(data) {
  return {
    content_id: 'formulario-modelo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
export var cardanChangeFormPlateNumber = function cardanChangeFormPlateNumber(data) {
  return {
    content_id: 'formulario-placa',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
export var cardanChangeVehicleClick = function cardanChangeVehicleClick(data) {
  return {
    content_id: 'alterar-veiculo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
export var cardanCleanSearch = function cardanCleanSearch(data) {
  return {
    content_id: 'buscar-sem-veiculo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
export var cardanProductAskSellerClick = function cardanProductAskSellerClick(data) {
  return {
    content_id: 'pergunte-ao-vendedor',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    item_id: data.sku,
    screenName: 'produto'
  };
};
export var cardanProductChangeVehicleClick = function cardanProductChangeVehicleClick(data) {
  return {
    content_id: 'alterar-veiculo',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    item_id: data.sku,
    screenName: 'produto'
  };
};
export var cardanProductView = function cardanProductView(data) {
  return {
    content_id: "cardan:".concat(data.mensagemRetorno),
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'view_content',
    item_id: data.sku,
    screenName: 'produto'
  };
};
export var cardanSearchModelClick = function cardanSearchModelClick(data) {
  return {
    content_id: 'procurar',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
export var cardanSearchPlateNumberClick = function cardanSearchPlateNumberClick(data) {
  return {
    content_id: 'procurar-por-placa',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'select_content',
    screenName: 'busca'
  };
};
export var cardanView = function cardanView(data) {
  return {
    content_id: 'cardan',
    content_type: "".concat(data.pagetype, ":cardan"),
    event: 'view_content',
    screenName: 'busca'
  };
};